<template>
  <div class="m-grid__item m-grid__item--fluid">
    <div class="m-content unsubscribe">
      <form class="m-form m-form--fit m-form--label-align-right main-form">
        <div class="col-md-12">
          <div class="m-portlet m-portlet--tab">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <h3 class="title_component">
                    {{ $t('message.unsubscribe.title') }}
                  </h3>
                </div>
              </div>
            </div>

            <h5 class="unsubscribe-description">
              <p>{{ $t('message.unsubscribe.description1') }}</p>
              <p>{{ $t('message.unsubscribe.description2') }}</p>
              <p>{{ $t('message.unsubscribe.description3') }}</p>
            </h5>

            <div class="m-portlet__body">
              <div class="m-section__content">
                <div ref="alert"></div>
                <div class="section_1 row">
                  <div class="section_1_container col-md-12">
                    <div class="section_1_head">
                      <h3 class="m-portlet__head-text_fixed">
                        {{ $t('message.unsubscribe.step_1_title') }}
                      </h3>
                    </div>
                    <div class="section_1_content">
                      <span>{{
                        $t('message.unsubscribe.step_1_content')
                      }}</span>
                      <a
                        class="section_1_link"
                        data-vs-link="download-example"
                        :href="`${baseUrl}assets/unsuscribeEmployees.csv`"
                        download
                        >{{
                          $t('message.unsubscribe.step_1_download_example')
                        }}</a
                      >
                      <span>{{
                        $t('message.unsubscribe.step_1_2_content')
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="section_2 row">
                  <div class="section_2_1_container col-md-12">
                    <h3 class="m-portlet__head-text_fixed">
                      {{ $t('message.unsubscribe.step_2_title') }}
                    </h3>
                    <div class="section_2_1_content col-md-6">
                      <select
                        data-vs-slect="unsubscribe"
                        class="form-control m-input eform_templates"
                        v-model="unsubscribe.selected"
                      >
                        <option
                          v-for="(item, i) in unsubscribe.options"
                          :data-vs-option-value="`unsubscribe-${i}`"
                          :key="item.name"
                          :value="item.name"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="section_3 row">
                  <div class="section_3_1 col-md-12">
                    <h3 class="m-portlet__head-text_fixed">
                      {{ $t('message.unsubscribe.step_3_title') }}
                    </h3>
                    <vue-dropzone
                      ref="dropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      @vdropzone-removed-file="removeFile"
                      @vdropzone-file-added="afterComplete"
                      @vdropzone-max-files-exceeded="onMaxFilesExceeded"
                      v-model="unsubscribe.file"
                    >
                    </vue-dropzone>
                    <div v-if="countLineFile > 0" class="dz-count-filename">
                      <span
                        >{{ $t('message.unsubscribe.count_filename_1') }}
                        {{ countLineFile }}
                        {{ $t('message.unsubscribe.count_filename_2') }}</span
                      >
                    </div>
                    <div class="title_dropzone">
                      {{ $t('message.unsubscribe.step_3_extension_dropzone') }}
                    </div>
                  </div>
                </div>
                <div class="btn-save">
                  <button
                    :disabled="isDisabledBtn"
                    data-vs-button="unsubscribe-save"
                    :class="{
                      'btn-primary-disabled': isDisabledBtn,
                      'btn-primary': !isDisabledBtn
                    }"
                    type="button"
                    class="btn"
                    @click.prevent="validPass"
                  >
                    {{ $t('message.unsubscribe.btn_save') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <MountingPortal mountTo="#modals" append>
      <div slot="manual" slot-scope="{ to }" class="some-styles">
        <portal :to="to">
          <div
            class="modal fade"
            id="unsubscribe-success"
            ref="vuemodal"
            tabindex="-1"
            role="dialog"
            aria-hidden="false"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="modal-text-1">
                    {{ $t('message.unsubscribe.text_modal_1') }}
                  </div>
                  <div class="modal-text-2">
                    {{ $t('message.unsubscribe.text_modal_2') }}
                  </div>
                  <div class="modal-btn">
                    <button
                      data-vs-button="go-to-list"
                      class="btn btn-secondary"
                      onclick="location.href='/s/employees/list'"
                      type="button"
                    >
                      {{ $t('message.unsubscribe.back_to_search') }}
                    </button>
                    <button
                      data-vs-button="go-to-process"
                      class="btn btn-primary"
                      type="button"
                      @click="redirecToProcessState"
                    >
                      {{ $t('message.unsubscribe.action_go_process') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </portal>
      </div>
    </MountingPortal>
  </div>
</template>
<script>
import { Vue } from 'vue-property-decorator'
import vueDropzone from 'vue2-dropzone'
import Alert from '@/components/generics/Alert.vue'
import { customTemplate } from './customTemplateDropzone'
import Unsubscribe from '../../apiClient/Unsubscribe'
import User from '../../apiClient/User'
import Swal from 'sweetalert2'

const MAX_FILES_REACHED = 1
const MAX_FILE_SIZE = 0.5 // MB

export default {
  components: {
    vueDropzone,
    Alert
  },
  data() {
    return {
      Author: 'ad89590098c7c6fbd7ad55aef965405e',
      api: Unsubscribe,
      unsubscribe: {
        selected: this.$t('message.unsubscribe.reasons.termination'),
        file: '',
        options: [
          { id: 1, name: this.$t('message.unsubscribe.reasons.termination') },
          { id: 2, name: this.$t('message.unsubscribe.reasons.contractEnd') },
          { id: 3, name: this.$t('message.unsubscribe.reasons.resignation') },
          { id: 4, name: this.$t('message.unsubscribe.reasons.retirement') },
          { id: 5, name: this.$t('message.unsubscribe.reasons.candidateDrop') },
          { id: 6, name: this.$t('message.unsubscribe.reasons.others') }
        ]
      },
      countLineFile: 0,
      hasFileAttached: false,
      removeFileTimeout: null,
      baseUrl: process.env.VUE_APP_BASE,
      dropzoneOptions: {
        url: 'http://localhost',
        autoProcessQueue: false,
        maxFiles: MAX_FILES_REACHED,
        maxFilesize: MAX_FILE_SIZE, // MB
        chunking: true,
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: false,
        previewTemplate: customTemplate(),
        acceptedFiles: 'text/csv,.csv',
        dictDefaultMessage: `<div><span class='cloud'></span></div><a style='font-weight:400'>${this.$t(
          'message.unsubscribe.dropzone.dragText'
        )} <span style='color:#2470A0'> ${this.$t(
          'message.unsubscribe.dropzone.selectText'
        )}<span></a>`,
        dictFileTooBig: this.$t('message.unsubscribe.dropzone.dictFileTooBig', {
          maxFilesize: MAX_FILE_SIZE
        }),
        dictInvalidFileType: this.$t(
          'message.unsubscribe.dropzone.dictInvalidFileType'
        ),
        dictRemoveFile: this.$t('message.unsubscribe.dropzone.dictRemoveFile'),
        dictMaxFilesExceeded: this.$t(
          'message.unsubscribe.dropzone.dictMaxFilesExceeded',
          { maxFiles: MAX_FILES_REACHED }
        )
      }
    }
  },
  created() {
    this.api = new Unsubscribe()
    this.user = new User()
  },
  beforeDestroy() {
    if (this.removeFileTimeout) {
      clearTimeout(this.removeFileTimeout)
      this.removeFileTimeout = null
    }
  },
  computed: {
    isDisabledBtn() {
      return !this.unsubscribe.file
    }
  },
  methods: {
    redirecToProcessState() {
      $('#unsubscribe-success').modal('hide')
      this.$router.push('/company/process-manager')
    },
    afterComplete(file) {      
      if (!this.validExtension(file)) {
        this.$refs.dropzone.removeFile(file)
        this.errorMessage('alert_format')
        return
      }
      
      if (this.hasFileAttached || this.unsubscribe.file) {
        this.$refs.dropzone.removeFile(file)
        this.errorMessage('max_files_reached')
        return
      }

      this.countRowsFile(file)
      this.unsubscribe.file = file
      this.hasFileAttached = true

      const progressElement = file.previewElement.querySelector('.dz-progress')
      if (progressElement) {
        progressElement.style.display = 'none'
      }
    },
    onMaxFilesExceeded(file) {
      this.$refs.dropzone.removeFile(file)
    },
    removeFile(file) {
      if (this.unsubscribe.file && this.unsubscribe.file === file) {
        this.countLineFile = 0
        this.unsubscribe.file = ''
        this.hasFileAttached = false
      }
      
      if (this.removeFileTimeout) {
        clearTimeout(this.removeFileTimeout)
      }
      
      this.removeFileTimeout = setTimeout(() => {
        if (this.$refs && this.$refs.dropzone && this.$refs.dropzone.dropzone) {
          const remainingFiles = this.$refs.dropzone.dropzone.files || []
          if (remainingFiles.length === 0) {
            this.countLineFile = 0
            this.unsubscribe.file = ''
            this.hasFileAttached = false
          }
        }
        this.removeFileTimeout = null
      }, 100)
    },
    validExtension(file) {
      if (
        file.type == 'text/csv' ||
        file.type == 'application/vnd.ms-excel' ||
        file.type == 'text/plain'
      ) {
        return true
      }
      return false
    },
    countRowsFile(file, callback) {
      const fr = new FileReader()
      fr.readAsText(file)
      fr.onload = (e) => {
        const tmp =
          e.target.result.split('\n').filter((item) => item.trim() !== '')
            .length - 1
        this.countLineFile = tmp
      }
    },
    errorMessage(msg) {
      const ComponentClass = Vue.extend(Alert)
      const instance = new ComponentClass({
        propsData: {
          role: 'danger',
          title: 'Error',
          message: this.$t('message.unsubscribe.' + msg)
        }
      }).$mount()
      this.$refs.alert.appendChild(instance.$el)
    },
    validPass() {
      Swal({
        title: this.$t('message.unsubscribe.unsubscribe_valid_pass').toString(),
        html: `<input type="password" id="pass-input" class="swal2-input">
        <input type="checkbox" onclick="const inputElement = document.getElementById('pass-input'); inputElement.type === 'password' ?inputElement.type = 'text' : inputElement.type = 'password';"> Mostrar contraseña  
        `,
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: this.$t(
          'message.unsubscribe.action_unsubscribe'
        ).toString(),
        showLoaderOnConfirm: false,
        reverseButtons: true,
        cancelButtonColor: '#88A09E',
        confirmButtonColor: '#54CAA6',
        cancelButtonText: this.$t(
          'message.unsubscribe.action_cancel'
        ).toString(),
        preConfirm: () => {
          const inputElement = document.getElementById('pass-input')
          const pwd = inputElement.value
          this.pwd = pwd
          return this.user
            .validPass(pwd)
            .then((response) => {
              if (response.data.results.data[0] == false) {
                throw new Error(response.data.results.data[0])
              }
            })
            .catch((error) => {
              Swal.showValidationMessage(
                this.$t('message.unsubscribe.text_fail_password').toString()
              )
            })
        }
      }).then((result) => {
        if (result.value) {
          this.save()
        }
      })
    },
    save() {
      this.api
        .unsubscribeEmployee(this.unsubscribe.file, this.unsubscribe.selected)
        .then((response) => {
          if (response.data.code === 200) {
            $('#unsubscribe-success')
              .modal({
                backdrop: 'static',
                keyboard: false
              })
              .modal('show')
            this.removeFile()
          }
        })
        .catch((error) => {
          this.errorMessage('error_' + error.response.data.code)
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import './public/assets/scss/components/_unsubscribe.scss';

::v-deep .dz-remove {
  pointer-events: all !important;
  cursor: pointer !important;
}

::v-deep .dz-preview.dz-file-preview {
  height: 166px !important;
}
</style>
